// extracted by mini-css-extract-plugin
export default {"host":"MenuExpander_host__Q6omo","host_collapsed":"MenuExpander_host_collapsed__hW2ie"};